export default Object.freeze({
  All: 0,
  MyRequests: 1,
  ReceivedRequests: 2,
  RevisionRequests: 3,
  BulkRequests: 4,
});
